/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.services
 * @name     csm.books.services.NewBooksData.type:Processor
 * @constructor
 * @param {object=} info  Processor info read from database.
 * @description
 * Processor information.
 *******************************************************************************/
ProcessorConfig.$inject = ['TypeFactoryProvider'];
/* @ngInject */ export function ProcessorConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'NewBooksData.Processor',
    //$type:     'csm.booksdb.data.Processor, CSMBooksDBCS',
    compile: function() {
      return {
        prototype: {
          id: 0, // Processor ID.
          orgID: 0, // Organization ID.
          type: 0, // Processor Type.
          accountName: null, // Name associated with processor for identification.
          forWS: false, // For Webstore flag.
          forPOS: false, // For POS flag.
          merchantAcctID: 0, // Merchant Account ID.
          undepFundsAcctID: 0, // Undeposited Funds Account ID.
          feeIncomeAcctID: 0, // Convenience Fee Income Account ID.
          procExpenseAcctID: 0, // Processing Fee Expense Account ID (PayPal).
          noSaleIncomeAcctID: 0, // Payment income from failed receipts account ID.
          apiTokens: null // Processor API tokens.
        },
        constructor: function(data) {
          this.defaultConstructor(data);
          this.apiTokens = Object.assign({}, this.apiTokens);
        }
      }
    }
  });
}
